import { type ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { cn } from '@/shared/lib/cn';
import { useT } from '@/shared/lib/i18n';

interface PageHeaderProps {
  title: ReactNode;
  onBack?: () => void;
  right?: ReactNode;
  className?: string;
}

export function PageHeader({ title, onBack, right, className }: PageHeaderProps) {
  const navigate = useNavigate();
  const t = useT();

  return (
    <div className={cn('flex items-center gap-3 px-[18px] py-3 pt-2', className)}>
      <button
        onClick={onBack ?? (() => navigate(-1))}
        className="text-text-secondary flex-shrink-0 -ml-1 p-1"
        aria-label={t('common.back')}
      >
        <svg
          width="26"
          height="26"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="m15 18-6-6 6-6" />
        </svg>
      </button>

      <div className="flex-1 flex items-center gap-2">{title}</div>

      {right && <div className="flex-shrink-0">{right}</div>}
    </div>
  );
}
